import React, { useState, useEffect } from 'react';
import { NavLink, Link, useNavigate } from 'react-router-dom';

export default function Navbar() {
  const navigate = useNavigate();
  const [scrolled, setScrolled]   = useState(false);
  const [menuOpen, setMenuOpen]   = useState(false);
  const [search, setSearch]       = useState('');

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const handleSearch = (e) => {
    e.preventDefault();
    if (search.trim()) {
      navigate(`/kerekparok?search=${encodeURIComponent(search.trim())}`);
      setSearch('');
      setMenuOpen(false);
    }
  };

  const navLinks = [
    { to: '/', label: 'Kezdőlap', end: true },
    { to: '/kerekparok', label: 'Kerékpárok' },
    { to: '/kviz', label: '✦ Kvíz' },
    { to: '/rolunk', label: 'Vélemények' },
    { to: '/szolgaltatasaink', label: 'Szolgáltatások' },
  ];

  return (
    <>
      <header className={`navbar${scrolled ? ' scrolled' : ''}`}>
        <div className="navbar__inner">
          <Link to="/" className="navbar__logo" onClick={() => setMenuOpen(false)}>
            <picture><source srcSet="/logo.webp" type="image/webp" /><img src="/logo.png" alt="Cruiser Shop" /></picture>
          </Link>

          <nav className="navbar__nav">
            {navLinks.map(l => (
              <NavLink key={l.to} to={l.to} end={l.end}
                className={({ isActive }) => `navbar__link${isActive ? ' active' : ''}`}>
                {l.label}
              </NavLink>
            ))}
          </nav>

          <div className="navbar__search-wrap">
            <form onSubmit={handleSearch} style={{ position: 'relative' }}>
              <span className="navbar__search-icon">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>
                </svg>
              </span>
              <input className="navbar__search" type="text" placeholder="Kerékpár keresése..."
                value={search} onChange={e => setSearch(e.target.value)} />
            </form>
          </div>

          <div className="navbar__actions">
            <a href="/kapcsolat" className="btn btn-primary btn-sm" style={{ marginLeft: 4 }}>
              Kapcsolat
            </a>
            <button className="navbar__icon-btn navbar__mobile-btn"
              onClick={() => setMenuOpen(v => !v)}
              aria-label={menuOpen ? 'Menü bezárása' : 'Menü megnyitása'}>
              {menuOpen ? (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
              ) : (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/>
                </svg>
              )}
            </button>
          </div>
        </div>
      </header>

      <div className={`mobile-menu${menuOpen ? ' open' : ''}`} role="dialog" aria-label="Navigációs menü">
        <form onSubmit={handleSearch} style={{ position: 'relative', marginBottom: 8 }}>
          <span style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)', color: 'var(--gray-400)' }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>
            </svg>
          </span>
          <input className="form-input" style={{ paddingLeft: 42, borderRadius: 'var(--r-full)' }}
            type="text" placeholder="Kerékpár keresése..." value={search} onChange={e => setSearch(e.target.value)} />
        </form>

        <div style={{ height: 1, background: 'var(--border)', margin: '8px 0 16px' }} />

        {navLinks.map(l => (
          <NavLink key={l.to} to={l.to} end={l.end}
            className={({ isActive }) => `mobile-menu__link${isActive ? ' active' : ''}`}
            onClick={() => setMenuOpen(false)}>
            {l.label}
          </NavLink>
        ))}

        <div style={{ height: 1, background: 'var(--border)', margin: '8px 0' }} />
        <a href="/kapcsolat" className="btn btn-primary btn-full" onClick={() => setMenuOpen(false)}>
          Kapcsolatfelvétel
        </a>
      </div>
    </>
  );
}
